import { SearchPredicate } from '@nx-smartmonkey/shared/domain';
import { PaginatedResult } from '@nx-smartmonkey/shared/interfaces';

import { Translation } from '../../../../domain/translation/Translation';
import { TranslationsTableColumn } from '../tableColumns/translations';

export enum BackofficeTranslationsActionType {
  SET_TRANSLATIONS_TABLE_COLUMNS = `SET_TRANSLATIONS_TABLE_COLUMNS`,
  SEARCH_TRANSLATIONS_SUCCESS = `SEARCH_TRANSLATIONS_SUCCESS`,
  SET_SEARCH_TRANSLATIONS_PREDICATES = `SET_SEARCH_TRANSLATIONS_PREDICATES`,
}

export interface SetTranslationsTableColumnsAction {
  type: BackofficeTranslationsActionType.SET_TRANSLATIONS_TABLE_COLUMNS;
  payload: Array<TranslationsTableColumn>;
}

export interface SearchTranslationsSuccessAction {
  type: BackofficeTranslationsActionType.SEARCH_TRANSLATIONS_SUCCESS;
  payload: {
    translations: PaginatedResult<Translation>;
  };
}

export interface SetSearchTranslationsPredicatesAction {
  type: BackofficeTranslationsActionType.SET_SEARCH_TRANSLATIONS_PREDICATES;
  payload: {
    predicates: Array<SearchPredicate>;
    predicatesBase64: string;
  };
}

export type BackofficeTranslationsActions =
  | SetTranslationsTableColumnsAction
  | SearchTranslationsSuccessAction
  | SetSearchTranslationsPredicatesAction;
